module.exports = __webpack_public_path__ + "static/media/5.0d00093b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/5.png
// module id = 1043
// module chunks = 0